import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/f774deb3335ef344be2f4793f6ebd557/4921c38636ad195fd01148c3e26c34c3.png" 
              alt="Logo" 
              className="h-10 w-auto mb-5 brightness-0 invert"
            />
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs mb-8">
              Professional funding strategy and business credit consulting. We prepare, position, and package you to qualify for real approvals.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-6">
              Company
            </h4>
            <ul className="space-y-4">
              <li>
                <Link to="/about" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-6">
              Services
            </h4>
            <ul className="space-y-4">
              <li>
                <Link to="/services" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Business Funding
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Personal Funding
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Business Credit Building
                </Link>
              </li>
              <li>
                <Link to="/buy-tradelines" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Buy Tradelines
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-6">
              Legal
            </h4>
            <ul className="space-y-4">
              <li>
                <Link to="/privacy" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Privacy
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/terms" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Terms
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/disclaimer" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Disclaimer
              </Link>
            </div>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
